import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import Header from './Header';
import Sidebar from './Sidebar';
import Canvas from './Canvas';
import Exporter from "./Exporter";
import Price from './Price';
import TeamModal from '../components/TeamModal';
import CopyrightModal from "../components/CopyrightModal";
//import ResponsiveAlert from "../components/ResponsiveAlert";
import LoadingOverlay from "../components/LoadingOverlay";

class Main extends Component {
  exporter = null;

  constructor(props) {
    super(props);

    this.checkout = this.checkout.bind(this);
    this.renderLoading = this.renderLoading.bind(this);
  }

  checkout() {
    this.exporter.getWrappedInstance().export();
  }

  renderTeamModal() {
    if (this.props.sidebar.teamModal) {
      return <TeamModal/>
    }
  }

  renderCopyrightModal() {
    if (this.props.sidebar.copyrightModal) {
      return <CopyrightModal onCheckout={this.checkout} images={this.exporter.getWrappedInstance().exportImages()} />
    }
  }

  renderLoading() {
    if (this.props.system.loading) {
      return <LoadingOverlay />;
    }
  }

  renderIEAlert() {
    let userAgent = window.navigator.userAgent.toUpperCase();
    if (!(userAgent.indexOf('MSIE') === -1 && userAgent.indexOf('TRIDENT') === -1)) {
      return (
        <div className="t-ie-alert">
          お使いのブラウザ(Internet Explorer)では正常に動作しない可能性があります。 <a href="https://www.google.com/intl/ja_jp/chrome/" target="_blank">Google Chrome</a>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="t-container-root">
        <div className="t-container-main">
          <Header onCheckout={this.checkout}/>

          <div className="t-content">
            <div className="t-content-left">
              <Sidebar />
            </div>
            <div className="t-content-right">
              <Canvas />
            </div>
          </div>
          <Exporter ref={node => {this.exporter = node;}}/>
          {this.renderIEAlert()}
        </div>

        {/*<Price />*/}

        {this.renderTeamModal()}
        {this.renderCopyrightModal()}
        <ReactTooltip effect="solid"/>

        {/*<ResponsiveAlert />*/}
        {this.renderLoading()}

      </div>
    );
  }
}

export default connect(f => f, {})(Main);



// WEBPACK FOOTER //
// ./src/containers/Main.js